import styled from 'styled-components';

export const IFrameWrap = styled.div`
  padding: 0 20px;
  height: calc(100% - 140px);
  width: 100%;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
`;

export const Iframe = styled.iframe`
  width: 100%;
  height: auto;
  border: none;
  display: block;
  min-height: 100%;
  -webkit-overflow-scrolling: touch;
`;
